export default "__VITE_ASSET__e97TUG6U__"